module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-row-expandable-arrow.9be97d60.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-row-expandable-arrow.png
// module id = 3835
// module chunks = 11